<template>
  <div class="tag">
    <el-scrollbar ref="scrollContainer" :vertical="false" class="scroll-container" @wheel.native.prevent="handleScroll">
      <slot />
    </el-scrollbar>
  </div>
</template>

<script>
const tagAndTagSpacing = 4 // tagAndTagSpacing

export default {
  name: 'ScrollPane',
  data() {
    return {
      left: 0
    }
  },
  computed: {
    scrollWrapper() {
      return this.$refs.scrollContainer.$refs.wrap
    }
  },
  mounted() {
    this.scrollWrapper.addEventListener('scroll', this.emitScroll, true)
  },
  beforeDestroy() {
    this.scrollWrapper.removeEventListener('scroll', this.emitScroll)
  },
  methods: {
    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 40
      const $scrollWrapper = this.scrollWrapper
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4
    },
    emitScroll() {
      this.$emit('scroll')
    },
    moveToTarget(currentTag) {
      const $container = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      const $scrollWrapper = this.scrollWrapper
      const tagList = this.$parent.$refs.tag

      let firstTag = null
      let lastTag = null

      // find first tag and last tag
      if (tagList.length > 0) {
        firstTag = tagList[0]
        lastTag = tagList[tagList.length - 1]
      }

      if (firstTag === currentTag) {
        $scrollWrapper.scrollLeft = 0
      } else if (lastTag === currentTag) {
        $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth
      } else {
        // find preTag and nextTag
        const currentIndex = tagList.findIndex(item => item === currentTag)
        const prevTag = tagList[currentIndex - 1]
        const nextTag = tagList[currentIndex + 1]

        // the tag's offsetLeft after of nextTag
        const afterNextTagOffsetLeft = nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagAndTagSpacing

        // the tag's offsetLeft before of prevTag
        const beforePrevTagOffsetLeft = prevTag.$el.offsetLeft - tagAndTagSpacing

        if (afterNextTagOffsetLeft > $scrollWrapper.scrollLeft + $containerWidth) {
          $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth
        } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
          $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tag{
  height: 40px;
  width: 100%;
  position: relative;

  ::v-deep.scroll-container {
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    width: 100%;
    float: left;

    .el-scrollbar__wrap{
      margin: 0!important;
      overflow: hidden;
      height: 40px;
      display: flex;
      align-items: center;

      .el-scrollbar__view{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        overflow: hidden;
        height: 100%;
        gap: 8px; /* 增加标签间距 */
        padding: 0 8px; /* 容器内边距 */

        // 标签项样式
        .tags-view-item {
          display: inline-flex;
          align-items: center;
          padding: 5px 12px;
          height: 32px;
          background: #FFFFFF;
          border-radius: 4px;
          font-weight: normal;
          font-size: 14px;
          color: #1D2129;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
          text-decoration: none;
          white-space: nowrap;
          flex-shrink: 0; /* 防止标签被压缩 */
          transition: all 0.3s ease;

          &:first-child {
            margin-left: 0;
          }

          &.active {
            border: 1px solid #165DFF;
            color: #165DFF;
          }

          .el-icon-close {
            margin-left: 6px; /* 增加关闭图标左边距 */
            width: 16px;
            height: 16px;
            border-radius: 50%;
            text-align: center;
            line-height: 16px;
            font-size: 12px;
            transition: all 0.3s ease;

            &:hover {
              background-color: #b4bccc;
              color: #FFFFFF;
            }
          }

          &:hover {
            background: #f5f7fa;
          }
        }
      }
    }

    .el-scrollbar__bar{
      display: none;
    }
  }
}
</style><template>
  <div class="tag">
    <el-scrollbar ref="scrollContainer" :vertical="false" class="scroll-container" @wheel.native.prevent="handleScroll">
      <slot />
    </el-scrollbar>
  </div>
</template>

<script>
const tagAndTagSpacing = 4 // tagAndTagSpacing

export default {
  name: 'ScrollPane',
  data() {
    return {
      left: 0
    }
  },
  computed: {
    scrollWrapper() {
      return this.$refs.scrollContainer.$refs.wrap
    }
  },
  mounted() {
    this.scrollWrapper.addEventListener('scroll', this.emitScroll, true)
  },
  beforeDestroy() {
    this.scrollWrapper.removeEventListener('scroll', this.emitScroll)
  },
  methods: {
    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 40
      const $scrollWrapper = this.scrollWrapper
      $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4
    },
    emitScroll() {
      this.$emit('scroll')
    },
    moveToTarget(currentTag) {
      const $container = this.$refs.scrollContainer.$el
      const $containerWidth = $container.offsetWidth
      const $scrollWrapper = this.scrollWrapper
      const tagList = this.$parent.$refs.tag

      let firstTag = null
      let lastTag = null

      // find first tag and last tag
      if (tagList.length > 0) {
        firstTag = tagList[0]
        lastTag = tagList[tagList.length - 1]
      }

      if (firstTag === currentTag) {
        $scrollWrapper.scrollLeft = 0
      } else if (lastTag === currentTag) {
        $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth
      } else {
        // find preTag and nextTag
        const currentIndex = tagList.findIndex(item => item === currentTag)
        const prevTag = tagList[currentIndex - 1]
        const nextTag = tagList[currentIndex + 1]

        // the tag's offsetLeft after of nextTag
        const afterNextTagOffsetLeft = nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagAndTagSpacing

        // the tag's offsetLeft before of prevTag
        const beforePrevTagOffsetLeft = prevTag.$el.offsetLeft - tagAndTagSpacing

        if (afterNextTagOffsetLeft > $scrollWrapper.scrollLeft + $containerWidth) {
          $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth
        } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
          $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tag{
  height: 40px;
  width: 100%;
  position: relative;

  ::v-deep.scroll-container {
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    width: 100%;
    float: left;

    .el-scrollbar__wrap{
      margin: 0!important;
      overflow: hidden;
      height: 40px;
      display: flex;
      align-items: center;

      .el-scrollbar__view{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        overflow: hidden;
        height: 100%;
        gap: 8px; /* 增加标签间距 */
        padding: 0 8px; /* 容器内边距 */

        // 标签项样式
        .tags-view-item {
          display: inline-flex;
          align-items: center;
          padding: 5px 12px;
          height: 32px;
          background: #FFFFFF;
          border-radius: 4px;
          font-weight: normal;
          font-size: 14px;
          color: #1D2129;
          line-height: 22px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
          text-decoration: none;
          white-space: nowrap;
          flex-shrink: 0; /* 防止标签被压缩 */
          transition: all 0.3s ease;

          &:first-child {
            margin-left: 0;
          }

          &.active {
            border: 1px solid #165DFF;
            color: #165DFF;
          }

          .el-icon-close {
            margin-left: 6px; /* 增加关闭图标左边距 */
            width: 16px;
            height: 16px;
            border-radius: 50%;
            text-align: center;
            line-height: 16px;
            font-size: 12px;
            transition: all 0.3s ease;

            &:hover {
              background-color: #b4bccc;
              color: #FFFFFF;
            }
          }

          &:hover {
            background: #f5f7fa;
          }
        }
      }
    }

    .el-scrollbar__bar{
      display: none;
    }
  }
}
</style>
